import React from 'react';
import RenderInput from "../TrafficSource/RenderInput";

const TrafficSourceStateGroupRenderInputs = ({ fieldType, editProps, data, disabled = false, defaultCategory }) => {

    switch (fieldType) {
        case 'blockReason':
            return (
                <RenderInput
                    item={{
                        label: "Block Reason",
                        key: "blockReason",
                        type: "autoComplete",
                        required: true,
                        val: 'allBlockReasons',
                        returnKey: 'name',
                        displayKey: 'name'
                    }}
                    disabled={disabled}
                    value={editProps.value || ''}
                    data={data}
                    handleFilterChange={value => {
                        editProps.onChange(value);
                    }}
                />
            );
        case 'expires':
            return (
                <RenderInput
                    item={{
                        label: "Expires",
                        key: "expires",
                        type: "dateTime",
                        required: false,
                        returnKey: 'expires',
                        displayKey: 'expires'
                    }}
                    disabled={disabled}
                    value={editProps.value || null}
                    data={data}
                    handleFilterChange={value => {
                        editProps.onChange(value);
                    }}
                />
            );
        default:
            return (
            <RenderInput
                item={{
                    label: 'Name',
                    key: 'name',
                    type: 'text',
                    required: true
                }}
                value={editProps.value || ''}
                data={data}
                disabled={false}
                handleInputChange={e => editProps.onChange(e.target.value)}
            />
        );
    }
};

export default TrafficSourceStateGroupRenderInputs;
